import logocar from '../images/logocar.webp';
import psiho from '../images/psiho.webp';
import insperian from '../images/insperian.webp';
import skilkids from '../images/skilkids.webp';
import ipo from '../images/ipo.webp';
import easy from '../images/easy.webp';
import mds from '../images/mds.webp';
import runo from '../images/runo.webp';
import school1 from '../images/school1.webp';
import mti from '../images/mti.webp';
import bonnie from '../images/bonnie.webp';
import lend from '../images/lend.webp';
import miin from '../images/miin.webp';
import tochkaznanii from '../images/tochkaznanii.webp';
import smart from '../images/smart.webp';
import merion from '../images/merion.webp';
import mbi from '../images/mbi.webp';
import mipo from '../images/mipo.webp';
import algo from '../images/algo.webp';

export const EDUCATION_ITEMS = [
  { naprav: 'Психология и коучинг', image: psiho, link: 'https://my.saleads.pro/s/6wph8?erid=2VtzqvtrNqM' },
  { naprav: 'Школа по подготовке к ЕГЭ и ОГЭ', image: insperian, link: 'https://my.saleads.pro/s/cvo45?erid=2VtzqvPR239' },
  { naprav: 'ИТ, дизайн и создание игр', image: skilkids, link: 'https://my.saleads.pro/s/zain6?erid=2VtzquibDyZ' },
  { naprav: 'Проф. переподготовка', image: ipo, link: 'https://my.saleads.pro/s/ehqrc?erid=2VtzqwhyoVH' },
  { naprav: 'Программирование для детей', image: easy, link: 'https://my.saleads.pro/s/x48fz?erid=2VtzqwwKThw' },
  { naprav: 'Юридические профессии', image: mds, link: 'https://my.saleads.pro/s/tn5se?erid=2Vtzqwb1Pyx' },
  { naprav: 'Дополнительное проф. образование', image: runo, link: 'https://my.saleads.pro/s/1r63x?erid=2VtzqxmPCfg' },
  { naprav: 'Доп. образование детей и взрослых', image: school1, link: 'https://my.saleads.pro/s/gfclt?erid=2VtzquXyySu' },
  { naprav: 'Большое количество направлений', image: mti, link: 'https://my.saleads.pro/s/jszp1?erid=2VtzqwFQ9oU' },
  { naprav: 'Разные направления дизайна', image: logocar, link: 'https://my.saleads.pro/s/23eog?erid=2VtzqxQJ1Qr' },
  { naprav: 'Разнообразные направления ИТ', image: bonnie, link: 'https://my.saleads.pro/s/blxij?erid=2VtzqwNpytA' },
  { naprav: 'Подготовка к ЕГЭ и ОГЭ', image: lend, link: 'https://my.saleads.pro/s/Jptq2?erid=2VtzqvZqGYW' },
  { naprav: 'Интегративная нутрициология', image: miin, link: 'https://my.saleads.pro/s/9o18b?erid=2VtzqwHS44W' },
  { naprav: 'Курсы для детей от 5 лет и до 11 класса ', image: tochkaznanii, link: 'https://my.saleads.pro/s/mig5J?erid=2VtzqwyFK4y' },
  { naprav: 'Институт психологии', image: smart, link: 'https://my.saleads.pro/s/0qj69?erid=2VtzqwBP3fk' },
  { naprav: 'Доступное IT-образование', image: merion, link: 'https://my.saleads.pro/s/h1yrv?erid=2Vtzqv9afD8' },
  { naprav: 'Современное бизнес-образование', image: mbi, link: 'https://my.saleads.pro/s/u82cm?erid=2VtzqweABux' },
  { naprav: 'Разные направления психологии', image: mipo, link: 'https://my.saleads.pro/s/k5bz0?erid=2VtzquX77Mp' },
  { id: 'algo-kids', naprav: 'Программирование для детей', image: algo, link: 'https://my.saleads.pro/s/y6Jeu?erid=2Vtzqv8BaEi' },
];

export const EDUCATION_CATALOG = {
  path: '/Education',
  label: 'Статьи и обучение',
  variant: 'education',
  prefix: 'education',
  ctaLabel: 'Подробнее',
  items: EDUCATION_ITEMS,
};
